import { useCallback, useEffect, useRef, useState } from "react";
import { setWorkingCase, workspacePreferences } from "../../../services/workspaceApi";
import { can } from "../../ui";
import { partnerEdition } from "../editions";

export const useWorkingCase = (access, pathname) => {
  const [activeCase, setActiveCase] = useState(null);
  const [error, setError] = useState(false);
  const sequence = useRef(0);
  const enabled = !!access && can(access, "case.view") && !partnerEdition(access);
  const selectCase = useCallback(async (id) => {
    if (!enabled) return;
    const seq = ++sequence.current;
    setActiveCase(null); setError(false);
    try { const r = await setWorkingCase(id); if (seq === sequence.current) setActiveCase(r.data.active_case); }
    catch { if (seq === sequence.current) setError(true); }
  }, [enabled]);
  useEffect(() => {
    if (!enabled) { setActiveCase(null); return; }
    const match = pathname.match(/^\/(?:ujms\/)?cases\/([^/]+)(?:\/|$)/) || pathname.match(/^\/(?:judge|clerk)\/session\/[^/]+\/case\/([^/]+)/);
    if (match) { selectCase(match[1]); return; }
    const seq = ++sequence.current;
    setError(false);
    workspacePreferences().then((r) => { if (seq === sequence.current) setActiveCase(r.data.active_case); }).catch(() => { if (seq === sequence.current) { setActiveCase(null); setError(true); } });
    return () => { sequence.current += 1; };
  }, [enabled, pathname, selectCase]);
  return { activeCase, selectCase, contextError: error };
};